module.exports = __webpack_public_path__ + "img/bw-logo.b430aaa4.png";